import { initCommerce } from './forkful-module-commerce.js?v=0cc5219ac10076f6';
import { renderSections, recipeTabs } from './forkful-module-sections.js?v=0cc5219ac10076f6';
import { initGallery } from './forkful-module-gallery.js?v=0cc5219ac10076f6';
import { initInformation } from './forkful-module-information.js?v=0cc5219ac10076f6';
import { initCart } from './forkful-module-cart.js?v=0cc5219ac10076f6';
import { initDialogs, openDialog, announce } from './forkful-module-ui.js?v=0cc5219ac10076f6';
import { initScrollReveals } from './forkful-module-reveal.js?v=0cc5219ac10076f6';
import { initOfferTimer } from './forkful-module-offer-timer.js?v=0cc5219ac10076f6';
import { initVideos } from './forkful-module-videos.js?v=0cc5219ac10076f6';
import { countries, currencies } from './forkful-module-localization.js?v=0cc5219ac10076f6';

renderSections();
initVideos();
initDialogs();
initInformation();
initGallery();
const cart=initCart();
window.ForkfulCart=cart;
initCommerce();
function openLinkedDialog() {
  const id = { '#cart':'cart-dialog', '#search':'search-dialog' }[location.hash];
  if (id) openDialog(id);
}
openLinkedDialog();
window.addEventListener('hashchange',openLinkedDialog);
initOfferTimer();
document.querySelector('[data-year]').textContent=new Date().getFullYear();


function selectTab(index,focus=false) {
  const current=(index+recipeTabs.length)%recipeTabs.length;
  document.querySelectorAll('[data-tab]').forEach((button,i)=>{
    button.setAttribute('aria-selected',String(i===current));
    button.tabIndex=i===current?0:-1;
    document.getElementById(`recipe-panel-${i}`).hidden=i!==current;
    if (focus && i===current) button.focus();
  });
}
document.querySelector('.recipe-tabs').addEventListener('click',event=>{
  const button=event.target.closest('[data-tab]');
  if (button) selectTab(Number(button.dataset.tab));
});
document.querySelectorAll('[data-recipe-jump]').forEach(button=>button.addEventListener('click',()=>{
  const index=Number(button.dataset.recipeJump);
  selectTab(index);
  document.getElementById('recipe-title').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  document.getElementById(`recipe-tab-${index}`).focus({preventScroll:true});
}));
document.querySelector('.recipe-tabs').addEventListener('keydown',event=>{
  const button=event.target.closest('[data-tab]');
  if (!button) return;
  const index=Number(button.dataset.tab);
  if (event.key==='ArrowRight'||event.key==='ArrowLeft') { event.preventDefault();selectTab(index+(event.key==='ArrowRight'?1:-1),true); }
  if (event.key==='Home'||event.key==='End') { event.preventDefault();selectTab(event.key==='Home'?0:recipeTabs.length-1,true); }
});

const sticky=document.querySelector('.sticky-purchase');
const backTop=document.querySelector('.back-top');
const mainButton=document.getElementById('main-add-button');
function updatePurchaseBarSpace() {
  document.documentElement.style.setProperty('--purchase-bar-height',`${Math.ceil(sticky.getBoundingClientRect().height)}px`);
}
updatePurchaseBarSpace();
if ('ResizeObserver' in window) new ResizeObserver(updatePurchaseBarSpace).observe(sticky);
else window.addEventListener('resize',updatePurchaseBarSpace);
function updateScrollControls() {
  sticky.classList.toggle('visible',mainButton.getBoundingClientRect().bottom<0);
  backTop.classList.toggle('visible',window.scrollY>650);
}
window.addEventListener('scroll',updateScrollControls,{passive:true});
window.addEventListener('resize',updateScrollControls);
backTop.addEventListener('click',()=>window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
updateScrollControls();
initScrollReveals();

